import config from '../config.json';
import { indexedDBBackend } from './indexeddb.js';

function fetchBackend(apiUrl) {
  return {
    async account(token) {
      const res = await fetch(`${apiUrl}/account/${token}`);
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async register(email) {
      const res = await fetch(`${apiUrl}/register/`, {
        method: 'POST',
        headers: { 'Content-type': 'application/json; charset=UTF-8' },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async projects(token) {
      const res = await fetch(`${apiUrl}/projects/${token}`);
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async load(token, id) {
      const res = await fetch(`${apiUrl}/load/${token}/${id}`);
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async save(token, id, data) {
      const res = await fetch(`${apiUrl}/save/${token}/${id}`, {
        method: 'POST',
        headers: { 'Content-type': 'application/json; charset=UTF-8' },
        body: JSON.stringify(data),
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async delete(token, id) {
      const res = await fetch(`${apiUrl}/delete/${token}/${id}`);
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async addproject(user, projectName, projectDescription) {
      const res = await fetch(`${apiUrl}/addproject/`, {
        method: 'POST',
        headers: { 'Content-type': 'application/json; charset=UTF-8' },
        body: JSON.stringify({ projectName, projectDescription, user }),
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },
  };
}

export function createBackend(apiUrl, standalone = config.standalone) {
  if (standalone) return indexedDBBackend;
  return fetchBackend(apiUrl);
}
